<script setup lang="ts" generic="T extends Record<string, unknown>">
import { computed } from "vue";
import { useDroppable } from "@vue-dnd-kit/core";
import type { MoveEventPayload } from "./types";

const props = defineProps<{
  at: number;
  levelList: T[];
  parentId: number | null;
  groups: string[];
  disable?: boolean;
}>();

const emit = defineEmits<{
  (e: "move", value: MoveEventPayload): void;
}>();

const { elementRef, isOvered } = useDroppable({
  groups: props.groups,
  data: computed(() => ({
    source: props.levelList,
    parentId: props.parentId,
    index: props.at,
  })),
  events: {
    onDrop: async (_store, payload) => {
      const dragged = payload.items?.[0]?.data;
      if (!dragged) return false;

      if (props.disable) return true;

      emit("move", {
        id: dragged.item.id as number,
        parentId: props.parentId,
        order:
          dragged.item.order < props.at &&
          dragged.item.parentId === props.parentId
            ? props.at - 1
            : props.at,
      });

      return true;
    },
  },
});
</script>

<template>
  <div
    class="between-drop"
    ref="elementRef"
    :class="{ 'between-overed': isOvered && !disable, disable }"
  />
</template>

<style scoped>
.between-drop {
  height: 6px;
  border-radius: 12px;
}
.between-overed {
  background: #222fc2;
}

.disable {
  background-color: transparent !important;
}
</style>
